import { ConfigResponse } from "../../../orchestrator-api-client";

export interface OfferConfig {
  minAmount: number;
  maxAmount: number;
  amountStep: number;
  minDuration: number;
  maxDuration: number;
  durationStep: number;
}

export const DEFAULT_OFFER_CONFIG: Readonly<OfferConfig> = {
  minAmount: 5000,
  maxAmount: 30000,
  amountStep: 500,
  minDuration: 12,
  maxDuration: 84,
  durationStep: 6,
};

const toPositiveNumber = (
  raw: string | undefined,
  fallback: number,
): number => {
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : fallback;
};

export const parseOfferConfig = ({
  configList,
}: ConfigResponse): OfferConfig => ({
  minAmount: toPositiveNumber(
    configList && configList.find((c) => c.key === "MIN_AMOUNT")?.value,
    DEFAULT_OFFER_CONFIG.minAmount,
  ),
  maxAmount: toPositiveNumber(
    configList && configList.find((c) => c.key === "MAX_AMOUNT")?.value,
    DEFAULT_OFFER_CONFIG.maxAmount,
  ),
  amountStep: toPositiveNumber(
    configList && configList.find((c) => c.key === "AMOUNT_STEP")?.value,
    DEFAULT_OFFER_CONFIG.amountStep,
  ),
  minDuration: toPositiveNumber(
    configList && configList.find((c) => c.key === "MIN_DURATION")?.value,
    DEFAULT_OFFER_CONFIG.minDuration,
  ),
  maxDuration: toPositiveNumber(
    configList && configList.find((c) => c.key === "MAX_DURATION")?.value,
    DEFAULT_OFFER_CONFIG.maxDuration,
  ),
  durationStep: toPositiveNumber(
    configList && configList.find((c) => c.key === "DURATION_STEP")?.value,
    DEFAULT_OFFER_CONFIG.durationStep,
  ),
});
